import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        classifierType: '=',
        translations: '=',
        editState: '=',
        addState: '='
    },
    template: `
        <div class="colholder mt10 w100p">
            <div class="col col11">
                <list-search
                    model="vm.filter.value"
                    placeholder="{{ 'classifier.Search by name' | translate }}"
                    on-change="vm.search()">
                </list-search>
            </div>
            <div class="col col10">
                <ul class="actions01 nomargin f-right">
                    <li class="primary">
                        <a ng-if="vm.canManageUsers" class="btn main nowrap" ng-click="vm.redirectToAdd()">
                            {{ vm.translations.addLabel }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <list-factory-empty ng-if="!vm.list.items.length" list="vm.list" show-add-message="!vm.list.lastQuery.value"></list-factory-empty>
        <div class="well" ng-if="vm.list.items.length">
            <div class="loader02" ng-if="vm.loading"></div>
            <table class="data01" datatable dt-options="vm.DATATABLES">
                <thead>
                <tr>
                    <th ng-class="vm.list.getSortClass('value')"><a ng-click="vm.list.sortBy('value')">{{ vm.translations.classifierName }}</a></th>
                    <th ng-class="vm.list.getSortClass('courseCount')"><a ng-click="vm.list.sortBy('courseCount')">{{ 'count.Courses' | translate}}</a></th>
                    <th ng-class="vm.list.getSortClass('userCount')"><a ng-click="vm.list.sortBy('userCount')">{{ 'count.Employees' | translate}}</a></th>
                    <th ng-if="vm.licenceModuleEnabled" ng-class="vm.list.getSortClass('licenceCount')"><a ng-click="vm.list.sortBy('licenceCount')">{{ 'count.Licences' | translate}}</a></th>
                    <th ng-class="vm.list.getSortClass('externalId')"><a ng-click="vm.list.sortBy('externalId')">{{ 'drl.From external source' | translate}}</a></th>
                    <th>&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                <tr ng-repeat="item in vm.list.items">
                    <td>{{ item.value }}</td>
                    <td>{{ item.courseCount }}</td>
                    <td>{{ item.userCount }}</td>
                    <td ng-if="vm.licenceModuleEnabled">{{ item.licenceCount }}</td>
                    <td>{{ item.externalId ? 'general.Yes' : 'general.No' | translate }}</td>
                    <td class="actions">
                        <a ng-if="vm.canManageUsers" class="btn edit" ng-click="vm.redirectToEdit(item.id)">{{ 'user.Edit' | translate }}</a>
                        <a ng-if="vm.canManageUsers" class="btn delete" ng-click="vm.delete(item)">{{ 'general.Delete' | translate }}</a>
                    </td>
                </tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
`
})
export default class {
    constructor ($translate, $state, DATATABLES, CLASSIFIER_ENUM, ClassifierResource, PrivilegeService, ModalService, TokenService, toastr) {
        this.$translate = $translate;
        this.$state = $state;
        this.DATATABLES = DATATABLES;
        this.PrivilegeService = PrivilegeService;
        this.TokenService = TokenService;
        this.classifierResource = ClassifierResource;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.ModalService = ModalService;
        this.toastr = toastr;
        this.loading = false;
    }

    $onInit () {
        this.canManageUsers = this.PrivilegeService.canManageUsers();
        this.licenceModuleEnabled = this.TokenService.isLicencePointsModuleEnabled();
        this.filter = {};
    }

    search () {
        this.list.pagination.currentPage = 1;
        this.list.fetch({ type: this.classifierType, value: this.filter.value });
    }

    redirectToEdit (id) {
        this.$state.go(this.editState, { id });
    }

    redirectToAdd () {
        this.$state.go(this.addState);
    }

    delete (item) {
        let confirmMessage = this.translations.deleteMessage;
        if (item.externalId) {
            confirmMessage = this.translations.deleteExternalMessage;
        }
        this.ModalService.confirm(confirmMessage, 'medium').then(() => {
            this.loading = true;
            this.classifierResource.delete({ id: item.id }).$promise.then(() => {
                this.toastr.success(this.$translate.instant(this.translations.deleteSuccessMessage));
                this.list.fetch();
            }).finally(() => {
                this.loading = false;
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/group/list/table/index.js